import { render } from "./task-board.vue?vue&type=template&id=6e9969e4"
import script from "./task-board.vue?vue&type=script&lang=js"
export * from "./task-board.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__